document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.momkis-hero').forEach((hero) => {
    const slides = [...hero.querySelectorAll('.momkis-hero__slide')];
    const dots = [...hero.querySelectorAll('.momkis-hero__dot')];

    const prevButton = hero.querySelector('.momkis-hero__arrow--prev');
    const nextButton = hero.querySelector('.momkis-hero__arrow--next');

    if (slides.length <= 1) return;

    let currentIndex = 0;
    let autoplayTimer = null;

    const autoplayEnabled = hero.dataset.autoplay === 'true';
    const autoplaySpeed = Number(hero.dataset.speed) || 5000;

    function showSlide(index) {
      slides[currentIndex]?.classList.remove('is-active');

      if (dots[currentIndex]) {
        dots[currentIndex].classList.remove('is-active');
        dots[currentIndex].setAttribute('aria-current', 'false');
      }

      currentIndex = (index + slides.length) % slides.length;

      slides[currentIndex]?.classList.add('is-active');

      if (dots[currentIndex]) {
        dots[currentIndex].classList.add('is-active');
        dots[currentIndex].setAttribute('aria-current', 'true');
      }
    }

    function nextSlide() {
      showSlide(currentIndex + 1);
    }

    function previousSlide() {
      showSlide(currentIndex - 1);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled) return;
      autoplayTimer = setInterval(nextSlide, autoplaySpeed);
    }

    nextButton?.addEventListener('click', () => {
      nextSlide();
      startAutoplay();
    });

    prevButton?.addEventListener('click', () => {
      previousSlide();
      startAutoplay();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.slideTo);
        showSlide(index);
        startAutoplay();
      });
    });

    hero.addEventListener('mouseenter', stopAutoplay);
    hero.addEventListener('mouseleave', startAutoplay);

    // Swipe mobile
    let touchStartX = 0;
    let touchEndX = 0;

    hero.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].screenX;
      },
      { passive: true }
    );

    hero.addEventListener(
      'touchend',
      (event) => {
        touchEndX = event.changedTouches[0].screenX;
        const distance = touchStartX - touchEndX;

        if (Math.abs(distance) < 50) return;

        if (distance > 0) {
          nextSlide();
        } else {
          previousSlide();
        }

        startAutoplay();
      },
      { passive: true }
    );

    // Accessibilité : pas d'autoplay si l'utilisateur préfère réduire les animations.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      stopAutoplay();
    } else {
      startAutoplay();
    }
  });
});
